module.exports = function() {
  return new Worker(__webpack_public_path__ + "5e17d654f6865e7265c1.worker.js");
};